/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'
axios.defaults.headers.common['Accept'] = 'application/json'

function prepareParams(config) {
    return new Promise((resolve, reject) => {
        var field = config.sort

        if (config.sortDirection === 'desc') {
            field = '-' + field
        }

        var params = {
            page: config.page,
            include: config.include,
            sort: field,
            per_page: config.per_page
        }

        if(config.search)
        params.search = config.search

        if (config.filters) {
            for (const [key, value] of Object.entries(config.filters)) {
                if (value !== '') {
                    params[`filter[${key}]`] = value
                }
            }
        }

        resolve(params)
    })
}

export default {
    getMyNeWPostsDashboard({ rootState, commit, dispatch }, payload) {
        const userId = payload && typeof payload === 'object' ? payload.userId : payload
        const period = payload && typeof payload === 'object' ? payload.period : null
        const axiosConfig = (payload && typeof payload === 'object' && payload.axiosConfig) || {}
        const periodParam = period ? `&period=${encodeURIComponent(period)}` : ''
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(
                        `${rootState.baseURL}/posts/dashboard?per_page=5&filter[with_operator]=${userId}${periodParam}`,
                        axiosConfig
                    )
                    .then((response) => {
                        dispatch(
                            'computePostsAnswers',
                            response.data.posts
                        ).then((posts) => {
                            commit('setPostsTotal', response.data.total)
                            commit('setPostsDashboard', posts)

                            resolve(response.data)
                        })
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    getPostsDashboard({ rootState, commit, dispatch }, payload) {
        const period = payload && typeof payload === 'object' ? payload.period : payload
        const axiosConfig = (payload && typeof payload === 'object' && payload.axiosConfig) || {}
        const periodParam = period ? `&period=${encodeURIComponent(period)}` : ''
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(`${rootState.baseURL}/posts/dashboard?per_page=5${periodParam}`, axiosConfig)
                    .then((response) => {
                        dispatch(
                            'computePostsAnswers',
                            response.data.posts
                        ).then((posts) => {
                            commit('setPostsTotal', response.data.total)
                            commit('setPostsDashboard', posts)

                            resolve(response.data)
                        })
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    getPostsList({ rootState, commit, dispatch }) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(
                        `${rootState.baseURL}/posts/dashboard?per_page=20&sort=-id`
                    )
                    .then((response) => {
                        dispatch(
                            'computePostsAnswers',
                            response.data.posts
                        ).then((posts) => {
                            commit('setPostsList', posts)
                            commit('setPostsTotal', response.data.total)

                            resolve(posts)
                        })
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    getPosts({ state, rootState, commit }, search = '') {
        return new Promise((resolve, reject) => {
            try {
                prepareParams(state.postsConfig).then((params) => {
                    if (search) params.search = search
                    axios
                        .get(`${rootState.baseURL}/posts`, {
                            params
                        })
                        .then((response) => {
                            commit('setPosts', response.data.posts)
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            } catch (error) {
                reject(error)
            }
        })
    },
    /**
     * Payload historique : l'objet de filtres directement (il porte lui-même une
     * clé `filters`, en plus de `include`, `page`, `per_page`...). Nouvelle forme :
     * `{ filters, axiosConfig }`, pour pouvoir passer `silence403` depuis un
     * écran qui doit dégrader au lieu d'être éjecté vers /403.
     *
     * L'enveloppe n'est reconnue que si le payload ne contient QUE `filters` et
     * `axiosConfig` : sinon un config historique serait réduit à son seul
     * sous-objet `filters`, et `include=answers` serait perdu.
     */
    getPostsLocation({ state, rootState, commit, dispatch }, payload) {
        const isWrapped =
            payload &&
            typeof payload === 'object' &&
            Object.keys(payload).every(
                (key) => key === 'filters' || key === 'axiosConfig'
            ) &&
            (payload.axiosConfig !== undefined || payload.filters !== undefined)
        const filters = isWrapped ? payload.filters : payload
        const axiosConfig = (isWrapped && payload.axiosConfig) || {}
        return new Promise((resolve, reject) => {
            try {
                prepareParams(filters || state.myPostsConfig).then((params) => {
                    axios
                        .get(`${rootState.baseURL}/posts`, {
                            params,
                            ...axiosConfig
                        })
                        .then((response) => {
                            dispatch(
                                'computePostsAnswers',
                                response.data.posts
                            ).then((posts) => {
                                commit('setMyPosts', posts)
                                resolve(response)
                            })
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            } catch (error) {
                reject(error)
            }
        })
    },

    getExportPosts({ state, rootState }, filters) {
        return new Promise((resolve, reject) => {
            try {
                prepareParams(filters || state.postsConfig).then((params) => {
                    axios
                        .get(`${rootState.baseURL}/posts/exports`, {
                            params
                        })
                        .then((response) => {
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            } catch (error) {
                reject(error)
            }
        })
    },

    exportPdfPost({ rootState, state }, content) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${rootState.baseURL}/posts/${state.post.id}/export/pdf`,
                    content
                )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getPost({ state, rootState, commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/posts/${id}`)
                .then((response) => {
                    dispatch('computePostAnswers', response.data.post).then(
                        (post) => {
                            commit('setPost', post)
                            commit('setStatuses', response.data.statuses)
                            commit('setHistory', response.data.history)
                            resolve(response)
                        }
                    )
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    sendNewComment({ state, rootState, commit }, message) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/posts/${state.post.id}/comments`, {
                    message
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    sendNewMessage({ state, rootState, commit }, content) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/posts/${state.post.id}/messages`, {
                    content
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    /**
     * A motivated transition: reason_id (predefined reason of the target status)
     * or reason (free text), plus the decision it illustrates.
     *
     * Only the keys actually present in `data` are forwarded: on the server an
     * absent key leaves the stored value untouched, while an explicit null
     * clears it. Sending them systematically would erase an estimated delivery
     * date every time an agent moves a card in the kanban.
     */
    updateStatus({ state, rootState, commit }, data) {
        const payload = {}
        const optional = [
            'reason_id',
            'reason',
            'estimated_delivery',
            'completion_media_id'
        ]
        optional.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                payload[key] = data[key]
            }
        })

        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${rootState.baseURL}/posts/${data.id}/statuses/${data.form_status_id}`,
                    payload
                )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPostsFilters({ state, rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/posts/filters`)
                .then((response) => {
                    commit('setPostsFilters', response.data)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    /**
     * Set new computed property to a set of post according to their answers
     * @param context
     * @param posts
     * @returns {Promise<unknown>}
     */
    computePostsAnswers(context, posts) {
        return new Promise((resolve, reject) => {
            try {
                // Selon l'appelant, la réponse peut ne pas embarquer `answers`
                // (include absent) : on dégrade au lieu de casser la vue.
                const list = (posts && posts.data) || []
                list.forEach((post) => {
                    const answers = (post && post.answers) || []
                    answers.forEach((answer) => {
                        switch (answer.name) {
                            // Automatic geolocation carries the same payload as a
                            // location answer, so it places the post on the map too.
                            case 'location':
                            case 'geolocation-automatic':
                                post.location = answer.value
                                break
                        }
                    })
                })

                resolve(posts)
            } catch (error) {
                reject(error)
            }
        })
    },
    /**
     * Set new computed property to a set of post according to their answers
     * @param context
     * @param post
     * @returns {Promise<unknown>}
     */
    computePostAnswers(context, post) {
        return new Promise((resolve, reject) => {
            try {
                post.answers.forEach((answer) => {
                    switch (answer.name) {
                        case 'location':
                        case 'geolocation-automatic':
                            post.location = answer.value
                            break
                    }
                })

                resolve(post)
            } catch (error) {
                reject(error)
            }
        })
    },
    searchUsersList({ rootState, commit }, search) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/users/find`, { params: { search } })
                .then((response) => {
                    commit('setUsersList', response.data.users)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPostHistories({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/posts/${id}/histories`)
                .then((response) => {
                    commit('setPostHistories', response.data.histories)
                    commit('setHistory', response.data.histories)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    saveUserAnswer({ commit }, attribute) {
        return new Promise((resolve, reject) => {
            try {
                commit('addAttribute', attribute)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    },
    sendPost({ rootState, state }, formId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/posts`, {
                    post: state.post,
                    form_id: formId,
                    locale: rootState.lang
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    updatePost({ rootState, state }, formId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/posts/${state.post.id}`, {
                    post: state.post,
                    form_id: formId,
                    locale: rootState.lang
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updatePostRacis({ rootState }, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/posts/${data.id}/racis`, data.data)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getVolumetry({ rootState }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/stats/volumetry`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPerformance({ rootState }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/stats/performance`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    updatePriority({ rootState, state }, data) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${rootState.baseURL}/posts/${data.id}/priority/${data.priority}`
                )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    remindOperator({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/posts/${id}/remind`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
